import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Components
import ChangePassword from "./ChangePassword";

// Utils
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

// Constants
import { API_RESPONSE_STATUS_CODES, HTTP } from "../Utils/Constants";

//Actions
import { changePasswordAction } from "./ChangePasswordAction";
import { logoutAction, setIsChangePasswordSuccess } from "../Login/LoginAction";

//Assets
import ChangePasswordImage from "../Assets/images/ic_password_change.svg";

//Styles
import "./ChangePassword.scss";

//Strings
import { Strings } from "../Translations/i18n";
import CustomModal from "../CustomUIComponents/CustomModal/CustomModal";
import { Button, Row } from "react-bootstrap";

class ChangePasswordContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
    };
  }
  handleLogoutAfterChangePassword = () => {
    this.props.logoutAction((response) => {
      if (response.status === HTTP.OK) {
        this.props.history.push(APPLICATION_CONFIGURATIONS.path.login);
      }
    });
  };

  handleChangePasswordSubmit = (oldpassword, newpassword) => {
    changePasswordAction(oldpassword, newpassword, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.setState({
          errorMessage: "",
        });
        this.props.setIsChangePasswordSuccess(true);
      } else {
        this.setState({
          errorMessage: Strings("errorInvalidOldPassword"),
        });
      }
    });
  };
  /* Handle on click of cancel of change pasword*/
  goToPreviousPage = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <div>
        {/* Modal open if password has been changed
	this is the general modal design to reuse at many places */}
        <CustomModal
          open={this.props.loginReducer.isChangePasswordSuccess}
          modalCloseOnEsc={false}
          modalCloseOnOverlayClick={false}
          modalShowCloseIcon={false}
          headerTextId="passwordChanged"
        >
          <Row className="modalImage">
            <img
              src={ChangePasswordImage}
              alt=""
              className="imageSpecification"
            />
          </Row>

          <Row className="message">
            {Strings("yourPasswordHasBeenchangedSuccessfully")}
          </Row>
          <Button variant=""
            className="buttonBackground button1 buttonMinWidth mt-2 mx-1"
            onClick={this.handleLogoutAfterChangePassword}
          >
            {Strings("loginAgain")}
          </Button>
        </CustomModal>
        <ChangePassword
          errorMessage={this.state.errorMessage}
          handleChangePasswordSubmit={this.handleChangePasswordSubmit}
          goToPreviousPage={this.goToPreviousPage}
          loginReducer={this.props.loginReducer}
        />
      </div>
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logoutAction: logoutAction,
      changePasswordAction: changePasswordAction,
      setIsChangePasswordSuccess: setIsChangePasswordSuccess,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    loginReducer: state.loginReducer,
  };
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(ChangePasswordContainer);
